import { Component, OnInit, ViewChild, ViewChildren, QueryList, AfterViewInit, ElementRef } from '@angular/core';
import {NgbAccordionDirective} from '@ng-bootstrap/ng-bootstrap';
import { IdentityProvider } from '@app/core/providers/identity/identity-provider';

@Component({
    selector: 'app-faq',
    templateUrl: './faq.component.html',
    styleUrls: ['./faq.component.scss'],
    standalone: false
})
export class FaqComponent implements OnInit, AfterViewInit {

  @ViewChild(NgbAccordionDirective) accordion: NgbAccordionDirective;

  constructor(
    private elem: ElementRef,
    private readonly identity: IdentityProvider) { }

  expandCollapseLabel = 'Expand All';
  isAllExpanded = false;

  ngOnInit() {
  }

  ngAfterViewInit() {
  }

  expandCollapseAllToggle() {
    if (this.isAllExpanded) {
      this.accordion.collapseAll();
      this.expandCollapseLabel = 'Expand All';
    } else {
      this.accordion.expandAll();
      this.expandCollapseLabel = 'Collapse All';
    }
    this.isAllExpanded = !this.isAllExpanded;
  }

  isLoggedIn(): boolean {
    return !!this.identity && this.identity.currentUser.isAuthenticated;
  }

  accountNumber(): string {
    return (!!this.identity && this.identity.currentUser.userProfile) ? this.identity.currentUser.userProfile.accountNumber : '';
  }
}
